import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const hotels = [
  {
    name: "Hotel Abades Nevada Palace",
    stars: "Hotel · 4 estrellas",
    detail:
      "Fácil acceso en coche tanto al centro de Granada como al lugar de la celebración.",
    link: "https://www.abadeshoteles.com/es/hotel-abades-nevada-palace-4-estrellas-granada/",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_9e44ceb2-a107-446e-9b9e-3beb4b654377/artifacts/c2h0liuv_875531779.jpg",
  },
  {
    name: "Boutique Hotel Luna Granada Centro",
    stars: "Hotel boutique",
    detail:
      "Un hotel boutique en pleno centro de Granada, ideal para moveros a pie por la ciudad y disfrutar de su ambiente.",
    link: "https://www.delunahotels.com/granada/hoteles/boutique-hotel-luna-granada-centro",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_9e44ceb2-a107-446e-9b9e-3beb4b654377/artifacts/7a6xnmu6_double-room-with-views-puerta-real-15xn88prxw.jpeg",
  },
];

const Accommodation = () => {
  return (
    <section
      id="stay"
      data-testid="stay-section"
      className="border-t border-[#c9c3b3] py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="flex items-start justify-between">
          <p className="corner-label text-[#8a8580]">(02) — Alojamiento</p>
        </div>

        <div className="mt-16 grid grid-cols-12 gap-6 md:gap-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="col-span-12 md:col-span-7"
          >
            <h2 className="display-xl">
              Dónde
              <br />
              alojarse.
            </h2>
          </motion.div>
          <div className="col-span-12 md:col-span-5 md:pt-8">
            <p className="body-lead max-w-md">
              Hemos seleccionado dos hoteles que recomendamos por su ubicación
              y comodidad. Si lo preferís, también encontraréis una amplia
              oferta de hoteles y Airbnb en el centro de Granada. El lugar de
              la celebración está a unos 15 minutos en taxi del centro, así que
              podéis alojaros donde os resulte más cómodo.
            </p>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-10 border-t border-[#c9c3b3] pt-16 md:grid-cols-2 md:gap-12">
          {hotels.map((h, i) => (
            <motion.article
              key={h.name}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1 }}
              data-testid={`hotel-card-${i}`}
              className="flex flex-col"
            >
              <div className="aspect-[4/3] w-full overflow-hidden">
                <img
                  src={h.image}
                  alt={h.name}
                  className="h-full w-full object-cover transition-transform duration-[1500ms] ease-out hover:scale-[1.03]"
                  loading="lazy"
                />
              </div>
              <div className="mt-6 flex items-center justify-between">
                <p className="corner-label text-[#8a8580]">{h.stars}</p>
                <span className="corner-label text-[#8a8580]">0{i + 1}</span>
              </div>
              <h3 className="mt-3 display-md">{h.name}</h3>
              <p className="mt-3 body-lead max-w-md">{h.detail}</p>
              <a
                href={h.link}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`hotel-link-${i}`}
                className="group mt-6 inline-flex w-fit items-center gap-2 corner-label nav-underline"
              >
                Ver hotel
                <ArrowUpRight
                  strokeWidth={1.5}
                  className="h-4 w-4 transition-transform duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                />
              </a>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Accommodation;
